import { render, staticRenderFns } from "./tranferNew.vue?vue&type=template&id=33ce39e0&scoped=true"
import script from "./tranferNew.vue?vue&type=script&lang=js"
export * from "./tranferNew.vue?vue&type=script&lang=js"
import style0 from "./tranferNew.vue?vue&type=style&index=0&id=33ce39e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ce39e0",
  null
  
)

export default component.exports